import script from "./ChooseDelivery.vue?vue&type=script&setup=true&lang=js"
export * from "./ChooseDelivery.vue?vue&type=script&setup=true&lang=js"

import "./ChooseDelivery.vue?vue&type=style&index=0&id=48df5e6c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48df5e6c"]])

export default __exports__